import { useCallback } from "react";
import { GoogleMap } from "types/map";

type UseMapZoomTrackerProps = {
  onZoomChange: (zoom: number) => void;
};

const trackedMaps = new WeakSet<GoogleMap>();

export const useMapZoomTracker = ({
  onZoomChange,
}: UseMapZoomTrackerProps) =>
  useCallback(
    (map: GoogleMap) => {
      if (trackedMaps.has(map)) {
        return;
      }

      trackedMaps.add(map);

      const updateZoom = () => {
        const zoom = map.getZoom();
        if (zoom !== undefined) {
          onZoomChange(zoom);
        }
      };

      map.addListener("zoom_changed", updateZoom);
      map.addListener("idle", updateZoom);
      updateZoom();
    },
    [onZoomChange],
  );
